import React, { useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import useWindowSize from 'shared/hooks/useWindowSize';
import LandingPage from './LandingPage';
import Where from './WherePage';
import When from './WhenPage';
import ConfirmPage from './ConfirmPage';
import Confetti from 'react-confetti';

function isLandingPage() {
  if (typeof window === 'undefined') return;
  const pathname = window.location.pathname;
  const separators = pathname.match(/\//g);
  return !!separators && separators.length === 2;
}

export default function GiftClaimPage({ match }) {
  const [runConfetti, setRunConfetti] = useState(false);

  useEffect(() => {
    setRunConfetti(isLandingPage());
  }, []);

  const { width, height } = useWindowSize();
  const headerHeight = 96;
  const footerHeight = 72;

  const landingPagePath = match.url;
  const wherePath = `${match.url}/where`;
  const whenPath = `${match.url}/when`;
  const confirmPath = `${match.url}/confirm`;

  return (
    <>
      <Switch>
        <Route
          exact
          path={landingPagePath}
          render={props => (
            <LandingPage
              {...props}
              wherePath={wherePath}
              confirmPath={confirmPath}
            />
          )}
        />

        <Route
          path={wherePath}
          render={props => (
            <Where {...props} prevPath={match.url} nextPath={whenPath} />
          )}
        />

        <Route
          path={whenPath}
          render={props => (
            <When {...props} prevPath={wherePath} nextPath={confirmPath} />
          )}
        />

        <Route
          path={confirmPath}
          render={props => (
            <ConfirmPage
              {...props}
              whenPath={whenPath}
              wherePath={wherePath}
              landingPagePath={landingPagePath}
            />
          )}
        />
      </Switch>

      {!!width && !!height && (
        <Confetti
          width={width}
          height={height}
          recycle={false}
          run={runConfetti}
          numberOfPieces={300}
          confettiSource={{
            x: 0,
            y: headerHeight,
            w: width,
            h: height - (headerHeight + (width <= 768 ? footerHeight : 0))
          }}
        />
      )}
    </>
  );
}
